import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a removeChild error and suppress it
    if (error && error.message && error.message.includes('removeChild')) {
      console.warn('Suppressed removeChild error in ErrorBoundary:', error);
      return { hasError: false, error: null };
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a removeChild error and suppress it
    if (error && error.message && error.message.includes('removeChild')) {
      console.warn('Suppressed removeChild error in componentDidCatch:', error);
      return;
    }
    
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="text-center">
            <h2>Something went wrong.</h2>
            <p>Please refresh the page and try again.</p>
            <button 
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 